import { render, staticRenderFns } from "./WithdrawalPage.vue?vue&type=template&id=f280e4de&scoped=true"
import script from "./WithdrawalPage.vue?vue&type=script&lang=js"
export * from "./WithdrawalPage.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalPage.vue?vue&type=style&index=0&id=f280e4de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f280e4de",
  null
  
)

export default component.exports